import React from "react";
import { Box } from "@mui/material";
import MobileAppRouter from "router/mobileRouter";

export default function MobileppContent() {
  return (
    <Box component="main">
      <MobileAppRouter />
    </Box>
  );
}
